import execCommand from 'execcommand-copy';

import { t } from '@gem/modules/i18n';
import { wait } from '@gem/utils';

import Tasks from 'APP/Tasks';
import { deepLinksModel } from 'APP/model/model';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

const request = async (message: ChatMessage): Promise<void> => {
  const { deepLink = null } = await deepLinksModel.createMessageDeepLink({
    groupId: message.groupId,
    messageId: message.id,
  });

  message.setDeepLink(deepLink);
};

export async function copyDeepLink(message: ChatMessage): Promise<void> {
  if (!message.deepLink) {
    try {
      request(message);
      const currentTime = Date.now();
      // this is a hack for safari. Blocks buffer insertion
      // breaks copy when async request or sleep > 900ms
      do {
        await wait(100);
      } while (!message.deepLink && Date.now() - currentTime < 900);
    } catch (e) {
      Tasks.app.showToast(t('something_went_wrong'));
      return;
    }
  }

  if (message.deepLink && execCommand.copy(message.deepLink)) {
    Tasks.app.showToast(t('common_link_copied'));
  } else {
    Tasks.app.showToast(t('something_went_wrong'));
  }
}
